import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import IpInfoPage from './pages/IpInfoPage';
import DnsLookupPage from './pages/DnsLookupPage';
import { useDeviceType } from './hooks/useDeviceType';

const AppContent = () => {
  const { colors } = useTheme();
  const { isMobile } = useDeviceType();
  
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      background: colors.background
    }}>
      <Header />
      <main style={{ 
        flex: 1, 
        padding: isMobile ? '1rem 10px' : '2rem 20px'
      }}>
        <Routes>
          <Route path="/" element={<IpInfoPage />} />
          <Route path="/dns" element={<DnsLookupPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App;
